import { SearchBar } from '@components/search-bar/main-search-bar.js'
import { initHeader } from '@layouts/header/assets/header.js'
import { initFooter } from '@layouts/footer/assets/footer.js'

SearchBar()
initHeader()
initFooter()
